<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full grid grid-cols-1 gap lg:grid-cols-2">
    <div class="lg:col-span-2 flex flex-col items-center gap-6">
        <h2>Ergebnisse sagen mehr als tausend Worte</h2>
        <p class="max-w-screen-sm text-center">
            Unsere Kunden wissen, wie wichtig es ist, digital zu überzeugen. Aber schau dir die
            Ergebnisse doch einfach selbst an.
        </p>
    </div>

    <!-- projects -->
    @if (items()) {
        @for (project of items(); track project) {
            <div class="w-full card muted !p-0 relative overflow-hidden group">
                <img [src]="project.fields.cover!.fields.file!.url" class="w-full" alt="" loading="lazy"/>

                <div
                    class="absolute left-0 bottom-0 bg-muted border-t-2 border-r-2 border-muted-dark pl-8 pr-4 pt-1.5 pb-2 rounded-tr-[1rem] select-none">
                <span class="font-normal text-sm leading-none text-dark">{{
                        project.fields.title
                    }}</span>
                </div>
            </div>
        }
    } @else {
        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>

        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>

        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>

        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>
    }
</div>
